import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const updateGroupMembers = async (
  state: IStore,
  clubId: string | number,
  groupId: number,
  data: any
) => {
  const response = await request.patch(`${api.admin.clubs}${clubId}/groups/${groupId}`, data);

  if (response.error) {
    return { errors: { groups: { msg: 'Error updating the group members' } } };
  }

  const groups = state.adminGroups.groups;

  const groupIndex = groups.findIndex(group => group.id === groupId);

  groups[groupIndex] = response;

  return {
    adminGroups: {
      groups
    }
  };
};
